import { gql } from '@apollo/client';
import { getDataFromMaybeSerialized } from '../helpers/getDataFromMaybeSerialized';
import { Slide, Timeline } from 'components/section/Timeline/Timeline';
import { Spacings } from '../helpers/SpacingControls/RangeControl';

export type Attributes = {
  items: Slide[];
  spacing?: Spacings;
};

type ComponentProps = {
  attributes: Attributes;
};

function Component({ attributes }: ComponentProps) {
  const { items, spacing } = attributes || {};

  if (!items) {
    return null;
  }

  const parsedItems = getDataFromMaybeSerialized(items);
  const parsedSpacing = getDataFromMaybeSerialized(spacing);

  return (
    <Timeline items={parsedItems} onClick={() => {}} spacing={parsedSpacing} />
  );
}

Component.config = {
  name: 'CreateBlockTimeline',
  interactive: true,
};

Component.fragments = {
  key: 'CreateBlockTimeline',
  entry: gql`
    fragment CreateBlockTimelineFragment on CreateBlockTimeline {
      attributes {
        items
        spacing
      }
    }
  `,
};

export default Component;
